module.exports = __webpack_public_path__ + "img/fio-dark.5da1ee68.svg";